import { Text } from "react-native";
import { useTranslation } from "react-i18next";
import { DEFAULT_MIN_AGE } from "@heraion/shared";
import { CheckboxRow } from "../primitives/CheckboxRow";
import { authFormStyles } from "./authFormStyles";
import type { UiTheme } from "../theme";

// #175: THE age-declaration box, for both doors that ask it: the first entry
// (WelcomeForm) and the gate for accounts made before it existed
// (AgeDeclarationOverlay). The sentence names DEFAULT_MIN_AGE, never a literal,
// and the declaration is dated when the box is TICKED, not when the form is
// sent: `tickedAt` is that moment on the device clock, null while unticked.
// The parent owns the state (it sends `tickedAt`); this owns how it is made.

export type AgeDeclarationCheckboxProps = {
  theme: UiTheme;
  tickedAt: string | null;
  onChange: (tickedAt: string | null) => void;
  disabled?: boolean;
  /** Say under the box, while unticked, that it is required. The gate shows
   *  it (the box is all there is to do there); the welcome form says it as
   *  its submit error instead. */
  hintWhileUnticked?: boolean;
};

export function AgeDeclarationCheckbox({
  theme,
  tickedAt,
  onChange,
  disabled = false,
  hintWhileUnticked = false,
}: AgeDeclarationCheckboxProps) {
  const { t } = useTranslation();
  const unticked = tickedAt === null;
  return (
    <>
      <CheckboxRow
        theme={theme}
        label={t("auth.ageDeclaration", { age: DEFAULT_MIN_AGE })}
        value={!unticked}
        onValueChange={(next) => onChange(next ? new Date().toISOString() : null)}
        disabled={disabled}
      />
      {hintWhileUnticked && unticked ? (
        <Text style={authFormStyles(theme).help}>{t("auth.welcome.ageRequired")}</Text>
      ) : null}
    </>
  );
}
